@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.content-info {
  margin-top: @space-16;
  color: var(--grey-600);
}

.content-button-panel {
  gap: @space-16;
  align-items: center;
  margin-top: @space-16;
}

.learn-more-btn {
  height: auto;
  font-size: 14px;
}

.feedback-btn {
  display: flex;
  align-items: center;
  > svg {
    height: 16px;
    width: 16px;
    margin-left: @space-4;
  }
}
